export const setInitialState = function(state, payload) {
  if (typeof payload.team === 'object') {
    state.team = payload.team
  }
  if (Array.isArray(payload.events)) {
    state.eventsLoaded = true
    state.events = payload.events
  }
  if (Array.isArray(payload.rinks)) {
    state.rinks = payload.rinks
  }
}

export const setCurrentTeam = function(state, payload) {
  state.currentTeam = payload
}

export const setCurrentRegistration = function(state, payload) {
  state.currentRegistration = payload
}

export const updateCurrentRegistration = function(state, payload) {
  state.currentRegistration = {
    ...state.currentRegistration,
    ...payload
  }
}

export const addRegistration = function(state, payload) {
  state.registrations.push(payload)
}

export const clearCurrentRegistration = function(state) {
  state.currentRegistration = {
    'lang': 'en',
    'fname': '',
    'mname': '',
    'lname': '',
    'bdate': '',
    'gender': '',
    'citizen': 'CAN',
    'address': '',
    'address2': '',
    'city': '',
    'state': '',
    'zip': '',
    'country': '',
    'email': '',
    'phone': '',
    'guardians': [
      {
        'fname': '',
        'lname': '',
        'relationship': '',
        'email': '',
        'phone': '',
        'phone2': ''
      },
      {
        'fname': '',
        'lname': '',
        'relationship': '',
        'email': '',
        'phone': '',
        'phone2': ''
      }
    ],
    'lts-checked': 0,
    'email-official-checked': 0,
    'email-offers-checked': 0,
    'email-local-checked': 0,
    'email-official-checked-ca': 0,
    'email-offers-checked-ca': 0,
    'email-local-checked-ca': 0,
    'liability-checked': 0,
    'liability-initials': '',
    'liability-youth-checked': 0,
    'liability-youth-initials': '',
    'admin_notes':''
  }
}

export const clearRegistrations = function(state) {
  state.registrations = []
}

export const setTransaction = function(state, payload) {
  state.transaction = payload
}

export const clearTransaction = function(state) {
  state.transaction = {}
}
